import axios from 'axios';
import { authHeader } from '../_helpers';
import config from '../_helpers/_config';

export const exportService = {
    getDefaultTrends,
    getCustomTrends,
    getTrendsConsumption,
    getTrendsReading,
    getStationsForProjects,
    getPresetsForProjects,
    getAlarmsFromStations,
    getCurrentAlarms,
    getAlarmsExportData,
    getEventsFromStations,
    getTrendsFromStations,
    getTrendsFromPreset,
    getEventsExportData
};

async function getDefaultTrends(projectId, variable) {
    const req_config = {
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
    };

    return await axios.get(`${config.API_LOCATION}/chartExport/trends/${variable}/default`, req_config);
}

async function getCustomTrends(projectId, variable, fromDate, fromTime, toDate, toTime) {
    const from = fromDate + 'T' + fromTime;
    const to = toDate + 'T' + toTime;

    const req_config = {
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
    };
    return await axios.get(`${config.API_LOCATION}/chartExport/trends/${variable}/custom/${from}/${to}`, req_config);
}

async function getTrendsConsumption(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/trends/consumption`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });
}

async function getTrendsReading(projectId, jsonData) {
    return axios({
        method: 'put',
        url: `${config.API_LOCATION}/chartExport/trends/reading`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}

async function getStationsForProjects(projectId) {
    const req_config = {
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
    };

    return await axios.get(`${config.API_LOCATION}/chartExport/stations`, req_config);
}

async function getPresetsForProjects(projectId) {
    const req_config = {
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
    };

    return await axios.get(`${config.API_LOCATION}/chartExport/presets`, req_config);
}

async function getAlarmsFromStations(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/alarms/generate`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}

async function getTrendsFromStations(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/trends/generate`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}

async function getTrendsFromPreset(projectId, presetId) {
    return axios({
        method: 'get',
        url: `${config.API_LOCATION}/chartExport/trends/generate/${presetId}`,
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())        
    });  
}

async function getCurrentAlarms(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/alarms/current`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}

async function getEventsFromStations(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/events/generate`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}

async function getAlarmsExportData(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/alarms/export`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}

async function getEventsExportData(projectId, jsonData) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/chartExport/events/export`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: jsonData
    });  
}
